import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSortable } from "utils/sortable/src";
import { CSS } from "@dnd-kit/utilities";
import { color2hex, hex2color } from "utils/colors";
import { editHabit } from "actions/habits";
import { showModal } from "actions/modal";
import { isChromeExtension, isPopupExtension } from "utils/extension";
import messages from "utils/messages";
import HabitControlPanel from "../HabitControlPanel/HabitControlPanel";
import moment from "moment";
export default function MenuItem({ id }) {
  const habit = useSelector((state) => state.habitsEntities[id] || {});
  const isFilteringGroup = useSelector((state) => state.boardFilter?.groupId);
  const [color, setColor] = useState(color2hex(habit.color));
  const history = useHistory();
  const span = useRef();
  const container = useRef();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef,
    isDragging,
    overCollapsedGroupId,
  } = useSortable({ id, data: habit });

  const borderColor = useSelector((state) => {
    const habit = state.habitsEntities[id];
    let groupId = habit?.group_id;
    if (isDragging && overCollapsedGroupId) groupId = overCollapsedGroupId;
    if (groupId) {
      let groupColor = state.groupsEntities[groupId].color || "green";
      return color2hex(groupColor);
    }
    return null;
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.75 : 1,
    zIndex: isDragging ? 10000 : 1,
    position: isDragging ? "relative" : undefined,
  };

  function handleColorChange(color) {
    setColor(color.hex);
    const newHabit = { ...habit, color: hex2color(color.hex) };
    dispatch(editHabit(newHabit));
  }

  function handleTimeChange(time) {
    const newTime = time && moment(time, "HH:mm").isValid() ? time : null;
    const newHabit = { ...habit, time: newTime };
    dispatch(editHabit(newHabit));
  }

  function showEditModal() {
    dispatch(showModal("editHabit", { title: messages.EDIT_HABIT, habit }));
  }

  function goToHabitPage() {
    if (!isPopupExtension()) history.push(`${user.id}/${habit.id}`);
  }

  const insideGroup = habit.group_id && !isFilteringGroup;

  const html = (
    <li
      ref={setNodeRef}
      style={style}
      key={id}
      className={"menuItemLI " + (!isChromeExtension() && "not-extension")}
    >
      <HabitControlPanel
        setActivatorNodeRef={setActivatorNodeRef}
        onEditClick={showEditModal}
        onColorChange={handleColorChange}
        color={color}
        habit={habit}
        attributes={attributes}
        listeners={listeners}
        onTimeChange={handleTimeChange}
      />
      <a
        style={{
          height: "100%",
          borderColor: borderColor || "transparent",
          borderLeftWidth: 5,
          borderLeftStyle: "solid",
          display: "flex",
          alignItems: "center",
        }}
        className="draggable habit-name"
        onClick={goToHabitPage}
      >
        <div
          style={{
            paddingLeft: insideGroup ? "10px" : "0px",
            lineHeight: "16px",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          }}
          ref={span}
        >
          {habit.name}
        </div>
      </a>
    </li>
  );

  return html;
}
